import { push } from 'connected-react-router/immutable';
import { Store } from 'redux';
import { initialize } from 'redux-form/immutable';
import { ActionsObservable } from 'redux-observable';

import { showMessageAction, showErrorAction } from 'containers/Notification/actions';
import DonationsApi from 'entities/donation/api';
import { selectUser } from 'entities/user/selectors';

import {
  FORM_IDENTIFIER,
  initSuccessAction,
  initFailedAction,
  submitSuccess,
  submitFailed,
  INIT,
  SUBMIT,
  InitAction,
  SubmitAction,
} from './types';

const init = (action$: ActionsObservable<InitAction>, store: Store) =>
  action$
    .ofType(INIT)
    .mergeMap(() => {
      const state = store.getState();
      const organizer = selectUser(state);

      return [
        initialize(FORM_IDENTIFIER, {
          amount: null,
          currency: organizer?.displayCurrency || 'USD',
          date: null,
          nonprofits: [],
          note: null,
          receiptUrl: null,
        }),
        initSuccessAction(),
      ];
    })
    .catch((e) => [
      initFailedAction(e),
      showErrorAction('Corporate donation logging form failed to initialize'),
    ]);

const submit = (action$: ActionsObservable<SubmitAction>) =>
  action$.ofType(SUBMIT).mergeMap(({ data }) =>
    DonationsApi.logCorporateDonation({
      ...data.toJSON(),
      amount: Number(data.get('amount')),
      donationProvider: 'External',
      nonprofits: data
        .get('nonprofits')
        .map((nonprofit) => nonprofit.get('id'))
        .toArray(),
    })
      .mergeMap((resultingAction) => [
        resultingAction,
        submitSuccess(data),
        showMessageAction('Corporate donation logged'),
        push('/donations/corporate'),
      ])
      .catch((error) => [submitFailed(error), showErrorAction('Corporate donation logging failed')])
  );

export default [init, submit];
